/* -------------------------------------------------- */
/*  src/Ontology/angel4.js                            */
/*  Full version – 背景锁定/解锁 + Popover 背景选择器 + 事件广播 */
/* -------------------------------------------------- */
import React, { useEffect, useRef, useState } from "react";
import { FiVolume2, FiVolumeX, FiGrid } from "react-icons/fi";
import MiniGLBViewer from "../pages/Spaceship";

/* 可切换的 Sketchfab 背景链接（仅 src 部分）*/
const BG_LINKS = [
  "https://sketchfab.com/models/247b6624576b48e59ee44af5a71e0e2f/embed?autostart=1",
      "https://sketchfab.com/models/bd2f7594b8434e3fa775e3fdaaeb2f2e/embed?autostart=1",
        "https://sketchfab.com/models/23567690020d4767a99f53ad5d59a161/embed?autostart=1",
         "https://sketchfab.com/models/bbbc335c94724061b5caaed3bb52b7cd/embed?autostart=1",

  "https://sketchfab.com/models/53fbb041023045b799cb4147ca4b006e/embed?autostart=1",


  "https://sketchfab.com/models/8f7259528f774ef49178e254ffac518b/embed?autostart=1",
  "https://sketchfab.com/models/164f19da64494642be5b4a203c1b1468/embed?autostart=1",
  "https://sketchfab.com/models/43be02c79a1c4092b774bacda18b2f34/embed?autostart=1",
  "https://sketchfab.com/models/fbd1baf5f56743e6bd4299ad91473b9a/embed?autostart=1",
  "https://sketchfab.com/models/7b5abc01fd804bc7b53da6259234eaf6/embed?autostart=1",
  "https://sketchfab.com/models/035706936c1c434e9f9a28e15cf72401/embed?autostart=1",
  "https://sketchfab.com/models/1f84ad2508674f749290b4d8a9561bfe/embed?autostart=1",
  "https://sketchfab.com/models/fd58a2f8e93447c18e52a5cb1c1e77dd/embed?autostart=1",
  "https://sketchfab.com/models/d81380e64c2c4b85b4cf58910f649312/embed?autostart=1",
  "https://sketchfab.com/models/b6d2b91c652148479400923a2cabb2d1/embed?autostart=1",
  "https://sketchfab.com/models/d4553cc2008242849214e4cbf8ad8551/embed?autostart=1",
  "https://sketchfab.com/models/2d12357275cd4205bd1d435e4b3b0feb/embed?autostart=1",
  "https://sketchfab.com/models/3c94c7da3b0648f1b67d9e795e9a4780/embed?autostart=1",
  "https://sketchfab.com/models/da862325a9dd4e8baa638fb72b9b2325/embed?autostart=1",
  "https://sketchfab.com/models/da4ed75e7e4745aaaf38f5ff3dbdde80/embed?autostart=1",
  "https://sketchfab.com/models/0742e636aa9a40b5865436511e3595cf/embed?autostart=1",
  "https://sketchfab.com/models/4b563f9b485142e591850395c2cadeb0/embed?autostart=1",
  "https://sketchfab.com/models/d3b03f0184234849a9618a576023e7d2/embed?autostart=1",
  "https://sketchfab.com/models/fc52bfbfe3424cd3988238d60c38a65e/embed?autostart=1",
  "https://sketchfab.com/models/7d09cb5b7dea4c4d84fac9b735eb4525/embed?autostart=1",
  "https://sketchfab.com/models/7241f0ba547d49ee97393cb4583f3916/embed?autostart=1",
  "https://sketchfab.com/models/d7b1cf114af248e4a9258eaa7325951f/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/2bfeebf1c60d40d7946c8e7f833a1289/embed?autospin=1&autostart=1",
  "https://sketchfab.com/models/7b53981c3461453da9fe11e5a7fd8aa8/embed?autostart=1",
  "https://sketchfab.com/models/2d22e05e4049493c9f47de897bb67c5e/embed?autostart=1",
  "https://sketchfab.com/models/26f81b24d83441ba88c7e80a52adbaaf/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/c2660ab00f4e4fc09de7503000d62430/embed?autostart=1",
  "https://sketchfab.com/models/8acd4f849f584400b77357ca8456ca73/embed?autospin=1&autostart=1",
  "https://sketchfab.com/models/0ce35d7f3a2d4a4eb747804f4d467840/embed?autostart=1",
  "https://sketchfab.com/models/3cb24182a8504d439ee4e3c500565ac5/embed?autostart=1",
  "https://sketchfab.com/models/860e5d4e2d2b420ca399b78220420c1e/embed?autostart=1",
  "https://sketchfab.com/models/166b9c9d8019489382bdabddfc3266e6/embed?autostart=1",
    "https://sketchfab.com/models/b811b00a737247ea9328326a05403ef0/embed?autostart=1&ui_infos=0",

  "https://sketchfab.com/models/32f50662b1ea484e99407c681485dc79/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/49c1b2058a3c4cb99ea8c4cef6ca24b5/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/95c1aca608e84e59b844e6e18919cbe9/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/c5acdec099b74f40bad56e5030c12e98/embed?autostart=1",

  "https://sketchfab.com/models/971c7ccb81784350a91f4fdf47a15cf1/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/d20958d1ca7c484fbea3fe4f87533f7f/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/ea875d1cbe4b4528803ab414fccccfb9/embed?autostart=1",
  "https://sketchfab.com/models/5ed32b5b5eba43c5b09cf2e488df2242/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/4dd852a3f08c4b1bb54044e1d753ebd5/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/f66e2e262f494475af0789603caf6180/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/89c3c1d4e73f43508474a72330d80a15/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/1dbff009f52f4f6b8f569be1a1e15c63/embed?autostart=1",
  "https://sketchfab.com/models/e410da98b1e5445eae2acafaaa53587d/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/9adb29306a6b44789e2c2b5544c79d91/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/8a3cea4da2184b5bb5bf68add9e28375/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/46a151d8e969418484c32cad47f6e1e6/embed?autospin=1&autostart=1",
  "https://sketchfab.com/models/072b42ac6b8d4c93a55f3c524e44b2f3/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/7e2699a0c7ad4c2ba282abedf4b2ed35/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/f31e3a37b3ae4e23aaf10f8741691784/embed?autostart=1",
  "https://sketchfab.com/models/7f64d63de4d9451d8e5ed8f4e22cc22e/embed?autostart=1",
  "https://sketchfab.com/models/1b04c610b29e4892a9afdfb8bce6d56c/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/950fe37138174cf0b216dd60e6e162fd/embed?autostart=1&ui_infos=0",
  "https://sketchfab.com/models/147ba6ce9a8447438960cc83b1e4b79e/embed?autostart=1",
  "https://sketchfab.com/models/f33bfc2cba9240c59a2933ff697b3e1f/embed?autostart=1&ui_infos=0",
     "https://sketchfab.com/models/2d2b77ef5d784508a32dee18c5aa210e/embed?autostart=1",
  "https://sketchfab.com/models/5e7126cb68d0432e9799910bc2f7bb05/embed?autostart=1",
  "https://sketchfab.com/models/75d7dbeb4d414cbd960bf16ec07987ce/embed?autostart=1",
  "https://sketchfab.com/models/fb78f4cc938144e6902dd5cff354d525/embed?autospin=1&autostart=1&ui_infos=0",
  "https://sketchfab.com/models/f379cf2c400645b8b22f3989cc5ff6dc/embed?autostart=1",
  "https://sketchfab.com/models/66f30155d0be4a7b9d6f7189a3758aea/embed?autostart=1",
  "https://sketchfab.com/models/f2f8e84f6eb443ff95cf6a40f624fdec/embed?autostart=1",
  "https://sketchfab.com/models/89daa5e21f0d4f08a59dba0d566e88bd/embed?autostart=1",
  "https://sketchfab.com/models/96657b093f064747a1e8216c93a32c0f/embed?autostart=1",
  "https://sketchfab.com/models/a93e93e3e41e49feac04747c6f540b05/embed?autostart=1",
  "https://sketchfab.com/models/c5d9b82fed36465797b4d278833a3781/embed?autostart=1",
  "https://sketchfab.com/models/e4d4d8150fcb4ed6a2c6efe959ad76d7/embed?autostart=1",
  "https://sketchfab.com/models/03b52b627be84c7bba2a60fa8a834aef/embed?autospin=1&autostart=1",
  "https://sketchfab.com/models/06d903f5dc5245699adf38192f77fbb6/embed?autostart=1",
  "https://sketchfab.com/models/a4df2f17e1f242ecb15787e3a886f31e/embed?autostart=1",
  "https://sketchfab.com/models/069aaa4b9dda4366b4379b551a605766/embed?autostart=1",
  "https://sketchfab.com/models/8560a2a642784faa97b60ce687bed45f/embed?autostart=1",
  "https://sketchfab.com/models/980b238c09cb414ca1cb29f1a623e83f/embed?autostart=1",
  "https://sketchfab.com/models/1663da94b7cd4d69b72a93311a102932/embed?autostart=1",
  "https://sketchfab.com/models/cc39b392a56c433ebcbe08535f36e4ff/embed?autostart=1",
  "https://sketchfab.com/models/a2b070bc0bc44fd081a6690220087d27/embed?autospin=1&autostart=1",
  "https://sketchfab.com/models/cb32545d75904bfc9de3bd65f169df8a/embed?autospin=1&autostart=1",
  "https://sketchfab.com/models/b251d7cdce3a4701b3fde7eea0f7d899/embed?autostart=1",
  "https://sketchfab.com/models/4cce6108341941729e463e56b59b18ae/embed?autospin=1&autostart=1",
  "https://sketchfab.com/models/374788d2818947d292c75cbda71c5171/embed?autospin=1&autostart=1",
  "https://sketchfab.com/models/a14cd297acee4b90ba00a7bc855db5b5/embed?autospin=1&autostart=1",
  "https://sketchfab.com/models/fafefdddfc9346f9ba76bb423e0a5089/embed?autospin=1&autostart=1",
  "https://sketchfab.com/models/fab3884d0cd0449193c2d43d1a1dd1a0/embed?autostart=1",
  "https://sketchfab.com/models/73e467dfc8a04914bb314a9410077858/embed?autospin=1&autostart=1",
  "https://sketchfab.com/models/be9cdf844d774e3ca6e638c10dade9bd/embed?autospin=1&autostart=1",
  "https://sketchfab.com/models/f4d8b63ee662417bad46b075561aaf7a/embed?autospin=1&autostart=1",
  "https://sketchfab.com/models/703570e76a9e4b9c89e90e5be7c9126f/embed?autospin=1&autostart=1",
  "https://sketchfab.com/models/869e1cd9b9514d0591dfecc12d2c078c/embed?autostart=1",
  "https://sketchfab.com/models/543ed233c1524defb2307258d07da755/embed?autostart=1",
  "https://sketchfab.com/models/d050a43ef26a4627b2a3655d14f16adb/embed?autostart=1"
];

export default function Angel4({ children }) {
  /* 背景索引 & 交互开关 */
  const [current, setCurrent]          = useState(0);
  const [bgInteractive, setBgInteractive] = useState(true);

  /* Popover 背景选择器 */
  const [showPicker, setShowPicker] = useState(false);
  const popoverRef = useRef(null);

  /* 音乐控制 */
  const audioRef = useRef(null);
  const [muted, setMuted] = useState(false);
  const [volume, setVolume] = useState(0.15);

  /* 初始化背景音乐 */
  useEffect(() => {
    const a = new Audio("/sounds/mail.mp3");
    a.loop = true;
    a.volume = volume;
    a.muted = muted;
    audioRef.current = a;
    a.play().catch(() => {});
    return () => {
      a.pause();
      a.src = "";
    };
  }, []);

  /* 音量滑动 */
  const onVolume = (e) => {
    const v = +e.target.value;
    setVolume(v);
    if (!muted) audioRef.current.volume = v;
  };

  /* 静音开关 */
  const toggleMute = () => {
    audioRef.current.muted = !audioRef.current.muted;
    setMuted(audioRef.current.muted);
  };

  /* ⬇️ 广播交互状态给外层 Canvas（Ontology 监听） */
  useEffect(() => {
    window.dispatchEvent(new CustomEvent("bg-interactive", { detail: bgInteractive }));
  }, [bgInteractive]);

  /* 点击外部关闭 Popover */
  useEffect(() => {
    if (!showPicker) return;
    const handleClickOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setShowPicker(false);
      }
    };
    window.addEventListener("mousedown", handleClickOutside);
    return () => window.removeEventListener("mousedown", handleClickOutside);
  }, [showPicker]);

  return (
<div style={{
  position: "relative",
  minHeight: "100vh",
  width: "100%",
  overflowX: "hidden",
  overflowY: "auto",
  background: "#fff"  // 避免黑背景
}}>
      {/* —— 顶部控制区 —— */}
      <div style={{ position: "fixed", top: "4rem", right: "1rem", zIndex: 250, display: "flex", gap: 8 }}>
        {/* Popover 开关 (🎨) */}
        <button
          onClick={() => setShowPicker(!showPicker)}
          style={{ padding: 8, background: "rgba(0,0,0,0.55)", border: "none",
                   borderRadius: 4, color: "#fff", cursor: "pointer" }}
        >
          <FiGrid size={18} />
        </button>

        {/* Lock / Unlock 背景交互 */}
        <button
          onClick={() => setBgInteractive(!bgInteractive)}
          style={{ padding: "6px 10px", fontSize: 12, border: "none", borderRadius: 4,
                   background: "rgba(0,0,0,0.55)", color: "#fff", cursor: "pointer" }}
        >
          {bgInteractive ? "Lock" : "Unlock"}
        </button>
      </div>

      {/* —— 背景选择 Popover —— */}
      {showPicker && (
        <div
          ref={popoverRef}
          style={{
            position: "fixed",
            top: "6.5rem",
            right: "1rem",
            zIndex: 260,
            background: "rgba(0,0,0,0.75)",
            backdropFilter: "blur(6px)",
            padding: "0.75rem",
            borderRadius: 8,
              maxHeight: "calc(100vh - 10rem)", // 给个上限高度
      overflowY: "auto",                 // 超出时垂直滚动
            display: "grid",
            gridTemplateColumns: "repeat(5, 38px)",
            gap: "0.5rem",
            transform: "scale(0.9)",
            animation: "popoverIn 150ms forwards",
          }}
        >
          {BG_LINKS.map((_, i) => (
            <button
              key={i}
              onClick={() => { setCurrent(i); setShowPicker(false); }}
              style={{
                width: 38,
                height: 38,
                fontSize: 12,
                border: "none",
                borderRadius: 4,
                cursor: "pointer",
                background: i === current ? "#fff" : "rgba(255,255,255,0.3)",
                color: i === current ? "#000" : "#fff"
              }}
            >
              {i + 1}
            </button>
          ))}
        </div>
      )}

      {/* —— 背景 iframe —— */}
      <div style={{ position: "fixed", inset: 0, zIndex: 0, overflow: "hidden" }}>
        <iframe
          key={current}
          src={BG_LINKS[current]}
          title={`bg-${current}`}
          frameBorder="0"
          allow="autoplay; fullscreen; xr-spatial-tracking"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "120%",
            height: "120%",
            transform: "translate(-50%,-50%)",
            border: "none",
            pointerEvents: bgInteractive ? "none" : "auto"
          }}
        />
      </div>

      {/* —— 小模型 —— */}
      <div style={{ position: "fixed", bottom: 88, left: 20, width: 64, height: 64, zIndex: 150 }}>
        <MiniGLBViewer url="/models/spaceship.glb" />
      </div>

      {/* —— 音量 & 静音 —— */}
      <div style={{ position: "fixed", bottom: 20, left: 20, display: "flex", gap: 8, zIndex: 200 }}>
        <button
          onClick={toggleMute}
          style={{ background: "rgba(0,0,0,0.35)", border: "none", borderRadius: 4,
                   padding: 8, color: "#fff", cursor: "pointer" }}
        >
          {muted ? <FiVolumeX size={20} /> : <FiVolume2 size={20} />}
        </button>
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={muted ? 0 : volume}
          onChange={onVolume}
          style={{ width: 90 }}
        />
      </div>

      

      {/* —— 业务 UI 层 —— */}
      <div
        style={{ position: "relative", zIndex: 100, width: "100%", height: "100%",
                 pointerEvents: "none" }}
      >
        {children}
      </div>

      {/* —— Popover 进入动画 —— */}
      <style>{`
        @keyframes popoverIn {
          to { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
